const MOBILE_UA = /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i
const TABLET_UA = /iPad|Tablet/i

function queryDeviceOverride() {
  try {
    const q = new URLSearchParams(window.location.search)
    const v = String(q.get('device') || '').toLowerCase()
    if (v === 'pc' || v === 'desktop') return 'pc'
    if (v === 'mobile' || v === 'm') return 'mobile'
  } catch {
    // ignore
  }
  return ''
}

export function detectIsMobile() {
  const override = queryDeviceOverride()
  if (override === 'mobile') return true
  if (override === 'pc') return false

  if (typeof window === 'undefined') return false
  const ua = navigator.userAgent || ''
  if (MOBILE_UA.test(ua)) return true
  if (TABLET_UA.test(ua) && window.matchMedia('(max-width: 1024px)').matches) return true
  if (window.matchMedia('(max-width: 768px)').matches) return true
  return false
}

/** 监听视口变化，回调 isMobile */
export function watchIsMobile(callback) {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return () => {}
  }
  const mql = window.matchMedia('(max-width: 768px)')
  const handler = () => callback(detectIsMobile())
  if (mql.addEventListener) mql.addEventListener('change', handler)
  else if (mql.addListener) mql.addListener(handler)
  return () => {
    if (mql.removeEventListener) mql.removeEventListener('change', handler)
    else if (mql.removeListener) mql.removeListener(handler)
  }
}
